import { render, staticRenderFns } from "./PlotsTable.vue?vue&type=template&id=0a717b7a&scoped=true&"
import script from "./PlotsTable.vue?vue&type=script&lang=js&"
export * from "./PlotsTable.vue?vue&type=script&lang=js&"
import style0 from "./PlotsTable.vue?vue&type=style&index=0&id=0a717b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a717b7a",
  null
  
)

export default component.exports